import { axiosInstance } from "utils";
import { CreateFileServerConnectionPayload, FileServerCredentials, FileServerPath } from "types";

export const listFileServer = async (credentials: FileServerCredentials) => {
    return await axiosInstance.post<FileServerPath[]>(
      "/connection/fileserver/list",
      credentials
    );
};

export const createFileServerConnection = async (payload: CreateFileServerConnectionPayload) => {
    return await axiosInstance.post<FileServerPath[]>(
      "/connection/fileserver",
      payload
    );
};